<ng-container *ngIf="dataSources.length > 0">
    <h1 class="title">Maintenance Actions</h1>
    <h5>Manage maintenance actions</h5>
    <acabim-datatable
        #dataTable
        [dataSources]="dataSources"
        (details)="setDetails($event)"
        [helpMessage]="helpMessage"
        hasDetailView="true"
        dataKey="id">
    </acabim-datatable>

    <div class="cas-button-row-wrapper">
        <button class="cas-button-action" (click)="addActionModal = true">ADD</button>
    </div>
</ng-container>

<ng-container *ngIf="addActionModal">
    <acabim-modal
            [display]="true"
            (status)="toggleAddStatus($event)"
            [title]="'Add action'"
            width="60vw"
            fixHeight="81vh">
        <acabim-admin-action-detail [setDetails]="null" (close)="closeHandler('add', $event)"></acabim-admin-action-detail>
    </acabim-modal>
</ng-container>

<ng-container *ngIf="archiveActionModal">
    <acabim-modal
            [display]="true"
            (status)="toggleArchiveStatus($event)"
            [title]="'Archive actions'"
            width="80vw"
            fixHeight="80vh">
        <acabim-admin-action-archive (close)="closeHandler('archived', $event)" [setDetails]="selectedActions"></acabim-admin-action-archive>
    </acabim-modal>
</ng-container>

<ng-container *ngIf="detailsActionModal && dataSources[0]?.showDetails">
    <acabim-modal
            [display]="true"
            (status)="toggleDetailStatus($event)"
            [title]="'Edit action'"
            width="60vw"
            fixHeight="81vh">
        <acabim-admin-action-detail [setDetails]="selectedAction" (close)="closeHandler('update', $event)"></acabim-admin-action-detail>
    </acabim-modal>
</ng-container>
